/* eslint-disable no-unused-vars, no-shadow */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An ISO 8601-encoded date */
  ISO8601Date: string;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: string;
};

export type Achievement = {
  __typename?: 'Achievement';
  attachment?: Maybe<Scalars['String']>;
  date: Scalars['ISO8601Date'];
  description: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type AchievementInput = {
  attachment?: InputMaybe<Scalars['String']>;
  date: Scalars['ISO8601Date'];
  description: Scalars['String'];
  title: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
};

/** Associate social account input */
export type AssociateSocialAccountInput = {
  provider: Scalars['String'];
  socialId: Scalars['ID'];
};

export type BooleanResult = {
  __typename?: 'BooleanResult';
  success: Scalars['Boolean'];
};

export type Companies = {
  __typename?: 'Companies';
  data: Array<Company>;
  pagination: Pagination;
};

export type Company = {
  __typename?: 'Company';
  applicationCount?: Maybe<Scalars['Int']>;
  businessDescription?: Maybe<Scalars['String']>;
  companyStaffs: Array<CompanyStaff>;
  corporatePhilosophy?: Maybe<Scalars['String']>;
  coverImage?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  employeesNumber?: Maybe<Scalars['Int']>;
  expiresOn?: Maybe<Scalars['ISO8601Date']>;
  foundedOn?: Maybe<Scalars['String']>;
  headquartersAddress?: Maybe<Scalars['String']>;
  homepage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  industry?: Maybe<Scalars['String']>;
  jobs: Array<Job>;
  likeCount?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  offices?: Maybe<Scalars['String']>;
  prefecture?: Maybe<Scalars['String']>;
  representative?: Maybe<Scalars['String']>;
  scoutCount?: Maybe<Scalars['Int']>;
  sentJobLikeCount?: Maybe<Scalars['Int']>;
  sentScoutCount?: Maybe<Scalars['Int']>;
};

export type CompanyStaff = {
  __typename?: 'CompanyStaff';
  company: Company;
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
};

export type EducationHistory = {
  __typename?: 'EducationHistory';
  course: Scalars['String'];
  department: Scalars['String'];
  faculty: Scalars['String'];
  fullName: Scalars['String'];
  grade: EducationHistoryGrade;
  graduatedOn?: Maybe<Scalars['String']>;
  highSchool?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  major: Scalars['String'];
  name: Scalars['String'];
  researchDetail?: Maybe<Scalars['String']>;
  researchSubject?: Maybe<Scalars['String']>;
};

export enum EducationHistoryGrade {
  /** b1 */
  B1 = 'b1',
  /** b2 */
  B2 = 'b2',
  /** b3 */
  B3 = 'b3',
  /** b4 */
  B4 = 'b4',
  /** b5 */
  B5 = 'b5',
  /** b6 */
  B6 = 'b6',
  /** c1 */
  C1 = 'c1',
  /** c2 */
  C2 = 'c2',
  /** c3 */
  C3 = 'c3',
  /** c4 */
  C4 = 'c4',
  /** d1 */
  D1 = 'd1',
  /** d2 */
  D2 = 'd2',
  /** d3 */
  D3 = 'd3',
  /** d4 */
  D4 = 'd4',
  /** graduated */
  Graduated = 'graduated',
  /** m1 */
  M1 = 'm1',
  /** m2 */
  M2 = 'm2',
  /** s1 */
  S1 = 's1',
  /** s2 */
  S2 = 's2',
  /** s3 */
  S3 = 's3',
  /** s4 */
  S4 = 's4',
  /** s5 */
  S5 = 's5',
}

/** Education history input */
export type EducationHistoryInput = {
  department: Scalars['String'];
  faculty: Scalars['String'];
  grade: EducationHistoryGrade;
  graduatedOn: Scalars['String'];
  highSchool?: InputMaybe<Scalars['String']>;
  major: Scalars['String'];
  name: Scalars['String'];
  researchDetail?: InputMaybe<Scalars['String']>;
  researchSubject?: InputMaybe<Scalars['String']>;
};

export type EducationalInstitution = {
  __typename?: 'EducationalInstitution';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type FeatureTopic = {
  __typename?: 'FeatureTopic';
  description: Scalars['String'];
  id: Scalars['ID'];
  jobs: Array<Job>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type FeatureTopics = {
  __typename?: 'FeatureTopics';
  data: Array<FeatureTopic>;
  pagination: Pagination;
};

export type FeaturedJob = {
  __typename?: 'FeaturedJob';
  id: Scalars['ID'];
  job: Job;
};

export type FeaturedJobs = {
  __typename?: 'FeaturedJobs';
  data: Array<FeaturedJob>;
  pagination: Pagination;
};

/** Search input */
export type FilterInput = {
  /** Field name */
  field?: InputMaybe<Scalars['String']>;
  /** Value */
  value: Scalars['String'];
};

export type Job = {
  __typename?: 'Job';
  accepted?: Maybe<Scalars['Boolean']>;
  characteristicLabels: Array<JobCharacteristicLabel>;
  company: Company;
  companyId: Scalars['ID'];
  coverImage?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  descriptionText: Scalars['String'];
  id: Scalars['ID'];
  idealCandidate: Scalars['String'];
  image1?: Maybe<Scalars['String']>;
  image2?: Maybe<Scalars['String']>;
  image3?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Scalars['String']>>;
  isFeatureable: Scalars['Boolean'];
  liked?: Maybe<Scalars['Boolean']>;
  members?: Maybe<Array<JobMember>>;
  status: JobStatus;
  statusesCanChangeTo: Array<JobStatus>;
  title: Scalars['String'];
};

export type JobCharacteristic = {
  __typename?: 'JobCharacteristic';
  id: Scalars['String'];
  jobCharacteristicLabels: Array<JobCharacteristicLabel>;
  name: Scalars['String'];
};

export type JobCharacteristicLabel = {
  __typename?: 'JobCharacteristicLabel';
  id: Scalars['ID'];
  jobCharacteristicId: Scalars['ID'];
  name: Scalars['String'];
};

/** Job characteristic label input */
export type JobCharacteristicLabelInput = {
  jobCharacteristicId: Scalars['ID'];
};

export type JobCharacteristics = {
  __typename?: 'JobCharacteristics';
  data: Array<JobCharacteristic>;
  pagination: Pagination;
};

export type JobLike = {
  __typename?: 'JobLike';
  accepted: Scalars['Boolean'];
  direction: JobLikeDirection;
  id: Scalars['String'];
  job: Job;
  jobSeeker: JobSeeker;
  jobSeekerId: Scalars['String'];
  liked: Scalars['Boolean'];
  messageThread?: Maybe<MessageThread>;
  sentAt?: Maybe<Scalars['String']>;
};

export enum JobLikeDirection {
  /** company_to_seeker */
  CompanyToSeeker = 'company_to_seeker',
  /** seeker_to_company */
  SeekerToCompany = 'seeker_to_company',
}

export type JobLikes = {
  __typename?: 'JobLikes';
  data: Array<JobLike>;
  pagination: Pagination;
};

export type JobMember = {
  __typename?: 'JobMember';
  image: Scalars['String'];
  name: Scalars['String'];
};

/** Job member input */
export type JobMemberInput = {
  /** Image */
  image: Scalars['String'];
  /** Name */
  name: Scalars['String'];
};

export type JobSeeker = {
  __typename?: 'JobSeeker';
  achievements: Array<Achievement>;
  address?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['Int']>;
  birthday?: Maybe<Scalars['String']>;
  certifications: Array<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  desiredCompanySizes: Array<Scalars['String']>;
  desiredJobTypes: Array<Scalars['String']>;
  desiredWorkLocations: Array<Scalars['String']>;
  educationHistory?: Maybe<EducationHistory>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  focusDetail?: Maybe<Scalars['String']>;
  focusSummary?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  introducedByName?: Maybe<Scalars['String']>;
  isInternal: Scalars['Boolean'];
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  placeOfBirth?: Maybe<Scalars['String']>;
  recruiterNote?: Maybe<RecruiterNote>;
  socialAccounts: Array<SocialAccount>;
  status: JobSeekerStatus;
  studyDetail: Scalars['String'];
  studyKeywords: Array<Scalars['String']>;
  thingsChangedAfterCovid?: Maybe<Scalars['String']>;
  toeicScore?: Maybe<Scalars['Int']>;
};

export enum JobSeekerStatus {
  /** accepted_offer */
  AcceptedOffer = 'accepted_offer',
  /** collecting_information */
  CollectingInformation = 'collecting_information',
  /** has_offer_and_looking_for_job */
  HasOfferAndLookingForJob = 'has_offer_and_looking_for_job',
  /** looking_for_internship */
  LookingForInternship = 'looking_for_internship',
  /** looking_for_job */
  LookingForJob = 'looking_for_job',
}

export type JobSeekers = {
  __typename?: 'JobSeekers';
  data: Array<JobSeeker>;
  pagination: Pagination;
};

export enum JobStatus {
  /** draft */
  Draft = 'draft',
  /** published */
  Published = 'published',
  /** submitted */
  Submitted = 'submitted',
  /** unpublished */
  Unpublished = 'unpublished',
}

export type Jobs = {
  __typename?: 'Jobs';
  data: Array<Job>;
  pagination: Pagination;
};

export type Message = {
  __typename?: 'Message';
  companyStaff?: Maybe<CompanyStaff>;
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  jobSeeker?: Maybe<JobSeeker>;
  kind: MessageKind;
  readByJobSeeker: Scalars['Boolean'];
  text: Scalars['String'];
};

export enum MessageKind {
  /** from_company */
  FromCompany = 'from_company',
  /** from_seeker */
  FromSeeker = 'from_seeker',
  /** notification */
  Notification = 'notification',
}

export type MessageThread = {
  __typename?: 'MessageThread';
  canAcceptScout: Scalars['Boolean'];
  canPostMessage: Scalars['Boolean'];
  company: Company;
  companyLastMessageSentAt?: Maybe<Scalars['ISO8601DateTime']>;
  createdAt: Scalars['String'];
  hasLastMessageRead?: Maybe<Scalars['Boolean']>;
  hasUnreadByJobSeeker: Scalars['Boolean'];
  id: Scalars['ID'];
  job: Job;
  jobSeeker: JobSeeker;
  lastMessageSentByCompany?: Maybe<Scalars['Boolean']>;
  latestMessage?: Maybe<Message>;
  messages: Array<Message>;
  origin: MessageThreadOrigin;
  scoutSentAt?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export enum MessageThreadOrigin {
  /** like_from_company */
  LikeFromCompany = 'like_from_company',
  /** like_from_seeker */
  LikeFromSeeker = 'like_from_seeker',
  /** scout */
  Scout = 'scout',
}

export type MessageThreads = {
  __typename?: 'MessageThreads';
  data: Array<MessageThread>;
  pagination: Pagination;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptScout?: Maybe<MessageThread>;
  associateSocialAccount?: Maybe<SocialAccount>;
  createAchievement?: Maybe<Achievement>;
  deleteAchievement: BooleanResult;
  disassociateSocialAccount: BooleanResult;
  likeJob?: Maybe<JobLike>;
  postMessage?: Maybe<MessageThread>;
  updateAchievement: Achievement;
  updateJob?: Maybe<Job>;
  updateJobSeeker?: Maybe<JobSeeker>;
};

export type MutationAcceptScoutArgs = {
  threadId: Scalars['String'];
};

export type MutationAssociateSocialAccountArgs = {
  input: AssociateSocialAccountInput;
};

export type MutationCreateAchievementArgs = {
  input: AchievementInput;
};

export type MutationDeleteAchievementArgs = {
  id: Scalars['String'];
};

export type MutationDisassociateSocialAccountArgs = {
  provider: SocialAccountProvider;
};

export type MutationLikeJobArgs = {
  id: Scalars['String'];
};

export type MutationPostMessageArgs = {
  text: Scalars['String'];
  threadId: Scalars['String'];
};

export type MutationUpdateAchievementArgs = {
  id: Scalars['String'];
  input: AchievementInput;
};

export type MutationUpdateJobArgs = {
  input: UpdateJobInput;
};

export type MutationUpdateJobSeekerArgs = {
  input: UpdateJobSeekerInput;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  total: Scalars['Int'];
};

/** Pagination input */
export type PaginationInput = {
  /** Page number */
  page?: InputMaybe<Scalars['Int']>;
  /** Items per page */
  perPage?: InputMaybe<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  companies: Companies;
  companiesById: Array<Company>;
  company?: Maybe<Company>;
  educationalInstitution?: Maybe<EducationalInstitution>;
  educationalInstitutions: Array<EducationalInstitution>;
  featureTopic?: Maybe<FeatureTopic>;
  featureTopicBySlug?: Maybe<FeatureTopic>;
  featureTopics: FeatureTopics;
  featuredJobs: FeaturedJobs;
  featuredJobsByTopicId: Array<FeaturedJob>;
  job?: Maybe<Job>;
  jobCharacteristics: JobCharacteristics;
  jobCharacteristicsById: Array<JobCharacteristic>;
  jobLikes: JobLikes;
  jobSeeker?: Maybe<JobSeeker>;
  jobSeekerMe?: Maybe<JobSeeker>;
  jobSeekers: JobSeekers;
  jobSeekersById: Array<JobSeeker>;
  jobs: Jobs;
  jobsByCompany?: Maybe<Jobs>;
  jobsById: Array<Job>;
  messageThread?: Maybe<MessageThread>;
  messageThreads: MessageThreads;
};

export type QueryCompaniesArgs = {
  filters?: InputMaybe<Array<FilterInput>>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
};

export type QueryCompaniesByIdArgs = {
  ids: Array<Scalars['ID']>;
};

export type QueryCompanyArgs = {
  id: Scalars['ID'];
};

export type QueryEducationalInstitutionArgs = {
  name: Scalars['String'];
};

export type QueryFeatureTopicArgs = {
  id: Scalars['ID'];
};

export type QueryFeatureTopicBySlugArgs = {
  slug: Scalars['String'];
};

export type QueryFeatureTopicsArgs = {
  filters?: InputMaybe<Array<FilterInput>>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
};

export type QueryFeaturedJobsArgs = {
  filters?: InputMaybe<Array<FilterInput>>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
};

export type QueryFeaturedJobsByTopicIdArgs = {
  featureTopicId: Scalars['ID'];
};

export type QueryJobArgs = {
  id: Scalars['ID'];
};

export type QueryJobCharacteristicsArgs = {
  filters?: InputMaybe<Array<FilterInput>>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
};

export type QueryJobCharacteristicsByIdArgs = {
  ids: Array<Scalars['ID']>;
};

export type QueryJobLikesArgs = {
  filters?: InputMaybe<Array<FilterInput>>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
};

export type QueryJobSeekerArgs = {
  id: Scalars['ID'];
};

export type QueryJobSeekersArgs = {
  filters?: InputMaybe<Array<FilterInput>>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
};

export type QueryJobSeekersByIdArgs = {
  ids: Array<Scalars['ID']>;
};

export type QueryJobsArgs = {
  filters?: InputMaybe<Array<FilterInput>>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
};

export type QueryJobsByCompanyArgs = {
  companyId: Scalars['ID'];
  pagination?: InputMaybe<PaginationInput>;
};

export type QueryJobsByIdArgs = {
  ids: Array<Scalars['ID']>;
};

export type QueryMessageThreadArgs = {
  id: Scalars['ID'];
};

export type QueryMessageThreadsArgs = {
  filters?: InputMaybe<Array<FilterInput>>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
};

export type RecruiterNote = {
  __typename?: 'RecruiterNote';
  comment: Scalars['String'];
  id: Scalars['ID'];
  isRead: Scalars['Boolean'];
};

export type SocialAccount = {
  __typename?: 'SocialAccount';
  profileUrl: Scalars['String'];
  provider: SocialAccountProvider;
};

export enum SocialAccountProvider {
  /** github */
  Github = 'github',
  /** note */
  Note = 'note',
  /** qiita */
  Qiita = 'qiita',
  /** twitter */
  Twitter = 'twitter',
}

/** Sort input */
export type SortInput = {
  /** Field name */
  field: Scalars['String'];
  /** Sort order */
  order: SortOrder;
};

export enum SortOrder {
  /** ascending */
  Asc = 'ASC',
  /** descending */
  Desc = 'DESC',
}

/** Update job input */
export type UpdateJobInput = {
  coverImage?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  idealCandidate?: InputMaybe<Scalars['String']>;
  image1?: InputMaybe<Scalars['String']>;
  image2?: InputMaybe<Scalars['String']>;
  image3?: InputMaybe<Scalars['String']>;
  images?: InputMaybe<Array<Scalars['String']>>;
  isFeatureable?: InputMaybe<Scalars['Boolean']>;
  jobCharacteristicLabels?: InputMaybe<Array<JobCharacteristicLabelInput>>;
  members?: InputMaybe<Array<JobMemberInput>>;
  status?: InputMaybe<JobStatus>;
  title?: InputMaybe<Scalars['String']>;
};

/** Update job seeker input */
export type UpdateJobSeekerInput = {
  address?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['String']>;
  certifications?: InputMaybe<Array<Scalars['String']>>;
  desiredCompanySizes?: InputMaybe<Array<Scalars['String']>>;
  desiredJobTypes?: InputMaybe<Array<Scalars['String']>>;
  desiredWorkLocations?: InputMaybe<Array<Scalars['String']>>;
  educationHistory?: InputMaybe<EducationHistoryInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  focusDetail?: InputMaybe<Scalars['String']>;
  focusSummary?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  introducedById?: InputMaybe<Scalars['ID']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  placeOfBirth?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<JobSeekerStatus>;
  studyDetail?: InputMaybe<Scalars['String']>;
  studyKeywords?: InputMaybe<Array<Scalars['String']>>;
  studyKeywordsString?: InputMaybe<Scalars['String']>;
  thingsChangedAfterCovid?: InputMaybe<Scalars['String']>;
  toeicScore?: InputMaybe<Scalars['Int']>;
};
